import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {RondeivuHttpClient} from "../../handlers";
import {INote, INoteCollection, INoteItem, NoteTypes} from "../../models";
import {HttpHeaders} from "@angular/common/http";
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NotesComponent } from 'src/app/components';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  private readonly BASE_URL = environment.rondeivu_api;
  private readonly FRAGMENT = '/notes';

  constructor(
    private httpClient: RondeivuHttpClient, 
    private dialog: MatDialog,
    private route: Router) {
    
  }

  launchNotes() {
    var segments = this.route.url.split('/').filter(x => !!x);

    console.log("Notes ->>>", segments)
    if (segments.includes("business-units")) {
      var dealIdIndex = segments.indexOf("business-units");
      console.log(segments[dealIdIndex + 1]);
      this.dialog.open(NotesComponent, {
        width: '500px',
        data: {
          notesType: NoteTypes.BUSINESSUNIT,
          id: segments[dealIdIndex + 1]
        }
      });
    }
    else if (segments.includes("deals")) {
      var dealIdIndex = segments.indexOf("deals");
      this.dialog.open(NotesComponent, {
        width: '500px',
        data: {
          notesType: NoteTypes.DEAL,
          id: segments[dealIdIndex + 1]
        }
      });
    }
    else if (segments.includes("mandates")) {
      var dealIdIndex = segments.indexOf("mandates");
      this.dialog.open(NotesComponent, {
        width: '500px',
        data: {
          notesType: NoteTypes.MANDATE,
          id: segments[dealIdIndex + 1]
        }
      });
    }
    
  }

  /**
   * Get the note collections for the desired object
   * @param type the type of the object
   * @param objectId the object id
   */
  getNoteCollections(type: NoteTypes, objectId: string): Observable<INoteCollection[]> {
    return this.httpClient.get<INoteCollection[]>(this.BASE_URL + this.FRAGMENT + '/' + type.toString() + '/' + objectId);
  }


  /**
   * Get the note collection by id
   * @param collectionId the collection id
   */
  getNoteCollection(collectionId: string): Observable<INoteItem[]> {
    return this.httpClient.get<INoteItem[]>(this.BASE_URL + this.FRAGMENT + '/' + collectionId);
  }

  /**
   * Add a note to a note collection
   * @param collectionId the object id
   * @param note the note
   */
  addNote(collectionId: string, note: string): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const payload = {
      note: note
    };
    return this.httpClient.post(this.BASE_URL + this.FRAGMENT + '/' + collectionId, payload, {headers: httpHeaders});
  }

  /**
   * Update a note
   * @param noteId the note id
   * @param note the note
   */
  updateNote(noteId: string, note: string): Observable<any> {
    const payload = {
      note: note
    };
    return this.httpClient.put(this.BASE_URL + this.FRAGMENT + '/' + noteId, payload);
  }

  /**
   * Delete a note
   * @param noteId the note id
   */
  deleteNote(noteId: string): Observable<any> {
    return this.httpClient.delete(this.BASE_URL + this.FRAGMENT + '/' + noteId);
  }
}
